import { defineComponent as _defineComponent } from 'vue';
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode } from "vue";
import { ApplyNewService } from '@/services/applyNew.service';
import { useService } from '@kaokei/use-vue-service';
import { computed } from 'vue';
import { SEX } from '@/utils';
export default /*#__PURE__*/_defineComponent({
  setup: function (__props) {
    var applyService = useService(ApplyNewService);
    var formState = computed(function () {
      return applyService.formState;
    });
    return function (_ctx, _cache) {
      var _component_a_radio_group = _resolveComponent("a-radio-group");
      var _component_a_form_item = _resolveComponent("a-form-item");
      var _component_a_col = _resolveComponent("a-col");
      return _unref(applyService).ConfSex.show ? (_openBlock(), _createBlock(_component_a_col, {
        key: 0,
        span: 12
      }, {
        default: _withCtx(function () {
          return [_createVNode(_component_a_form_item, {
            label: "考生性别：",
            name: "sex"
          }, {
            default: _withCtx(function () {
              return [_createVNode(_component_a_radio_group, {
                value: _unref(formState).sex,
                "onUpdate:value": _cache[0] || (_cache[0] = function ($event) {
                  return _unref(formState).sex = $event;
                }),
                size: "large",
                options: _unref(SEX)
              }, null, 8, ["value", "options"])];
            }),
            _: 1
          })];
        }),
        _: 1
      })) : _createCommentVNode("", true);
    };
  }
});